import { IPredictedLineupsHp } from '@sky-it-livedata/livedata-sports-design-system';
import React, { Suspense } from 'react';

import { IComponentModel } from '../../typings/common-types';
import { validateModel } from '../../utils/props-validator';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const CompetitionPredictedLineupsWrapper = React.lazy(() => import('./competition-predicted-lineups'));

export interface IDynamicCompetitionPredictedLineups extends IComponentModel<IPredictedLineupsHp> {
  // eslint-disable-next-line react/require-default-props
  live?: boolean;
}

const DynamicCompetitionPredictedLineups = ({
  /* istanbul ignore next: default value */ model = {} as IPredictedLineupsHp,
  /* istanbul ignore next: default value */ query = {},
  /* istanbul ignore next: default value */ children = null,
  /* istanbul ignore next: default value */ live = false,
}: IDynamicCompetitionPredictedLineups) => (
  <Suspense fallback={<HtmlWrapper html={children} />}>
    <CompetitionPredictedLineupsWrapper
      live={live}
      initialModel={validateModel(model) as IPredictedLineupsHp}
      query={validateModel(query)}
    />
  </Suspense>
);

export default DynamicCompetitionPredictedLineups;
